import kakaopayLogo from '@/assets/payment/kakaopay.png'
import npayLogo from '@/assets/payment/npay.svg'

import type { RegisteredCard } from '../CardCarousel'
import { CardCarousel } from '../CardCarousel'

import {
  CardCarouselWrap,
  LogoBadge,
  MethodCard,
  MethodHeading,
  OptionLabel,
  OptionRow,
  RadioInner,
  RadioOuter,
} from './styles'

/**
 * 이번 phase UI 노출 결제수단 3종.
 * 계좌이체('transfer')·퀵계좌이체('toss')는 다음 phase로 보류 — 비즈니스 로직(sdk/api/types)은 유지.
 */
export type PaymentMethod = 'card' | 'kakaopay' | 'naverpay'

interface LogoOption {
  method: PaymentMethod
  label: string
  logo?: string
}

/** 카드 결제(캐러셀 포함) 외의 단순 결제수단 — 라디오 + 라벨(+로고)만 */
const SIMPLE_OPTIONS: LogoOption[] = [
  { method: 'kakaopay', label: '카카오페이', logo: kakaopayLogo },
  { method: 'naverpay', label: '네이버페이', logo: npayLogo },
]

function Radio({ selected }: { selected: boolean }) {
  return <RadioOuter selected={selected}>{selected && <RadioInner />}</RadioOuter>
}

interface PaymentMethodCardProps {
  selected: PaymentMethod
  onSelect: (method: PaymentMethod) => void
  /** GET /payments/methods 결과 — 카드 결제 분기 시 캐러셀에 노출. 명세 확정 전까진 빈 배열 */
  cards?: RegisteredCard[]
  /** 캐러셀 마지막 슬라이드(AddCardSlide) 클릭 시 호출 — 카드 등록 진입점 */
  onAddCard?: () => void
  /** 현재 캐러셀에서 보고 있는 카드 id (결제 대상). add 슬라이드면 null */
  selectedCardId?: string | null
  /** 캐러셀 스와이프로 보이는 슬라이드가 바뀔 때 — 카드면 id, add 슬라이드면 null */
  onSelectCard?: (id: string | null) => void
}

export function PaymentMethodCard({
  selected,
  onSelect,
  cards = [],
  onAddCard,
  selectedCardId,
  onSelectCard,
}: PaymentMethodCardProps) {
  return (
    <MethodCard>
      <MethodHeading>결제 수단</MethodHeading>

      <OptionRow
        type='button'
        onClick={() => onSelect('card')}
      >
        <Radio selected={selected === 'card'} />
        <OptionLabel>카드 결제</OptionLabel>
      </OptionRow>
      {selected === 'card' && (
        <CardCarouselWrap>
          <CardCarousel
            cards={cards}
            onAddCard={onAddCard ?? (() => undefined)}
            selectedCardId={selectedCardId}
            onSelectCard={onSelectCard}
          />
        </CardCarouselWrap>
      )}

      {SIMPLE_OPTIONS.map((option) => (
        <OptionRow
          key={option.method}
          type='button'
          onClick={() => onSelect(option.method)}
        >
          <Radio selected={selected === option.method} />
          {option.logo && (
            <LogoBadge
              src={option.logo}
              width={40}
              height={24}
              alt=''
            />
          )}
          <OptionLabel>{option.label}</OptionLabel>
        </OptionRow>
      ))}
    </MethodCard>
  )
}
